import { useEffect } from "react"
import { Link, useSearchParams } from "react-router-dom"
import {CheckCircle} from 'lucide-react'
import { useLang } from "@/context/LanguageContext"

export default function Success() {
  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get("session_id")
  const { t } = useLang()

  useEffect(() => {
    // Clear cart from localStorage when reaching success page
    localStorage.removeItem("clips-on-cart")
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ backgroundColor: "#F8F2EB" }}>
      <div className="max-w-md w-full text-center">
        <div className="mb-8 flex justify-center">
          <CheckCircle size={80} strokeWidth={1} style={{ color: "#E1593F" }} />
        </div>
        
        <h1 className="text-3xl mb-4" style={{ color: "#82391F", letterSpacing: "4px" }}>
          {t("Merci pour votre commande !", "Thank you for your order!")}
        </h1>
        
        <p className="mb-4" style={{ color: "rgba(13, 12, 11, 0.6)", fontSize: "17px" }}>
          {t(
            "Votre paiement a été confirmé.",
            "Your payment has been confirmed."
          )}
        </p>

        <p className="mb-8" style={{ color: "rgba(13, 12, 11, 0.55)", fontSize: "15px", lineHeight: "1.7" }}>
          {t(
            "Un reçu de paiement vous a été envoyé par email par Stripe. Vérifiez votre dossier spam si nécessaire.",
            "A payment receipt has been sent to your email by Stripe. Please check your spam folder if needed."
          )}
        </p>

        {sessionId && (
          <p className="text-xs mb-8" style={{ color: "rgba(13, 12, 11, 0.3)" }}>
            {t("Référence de commande :", "Order reference:")} {sessionId}
          </p>
        )}

        <Link
          to="/"
          className="inline-block px-8 py-4 text-white text-xs tracking-[0.2em] uppercase transition-colors duration-300"
          style={{ backgroundColor: "#E1593F" }}
          onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#C4462E")}
          onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#E1593F")}
        >
          {t("Retour à l'accueil", "Back to home")}
        </Link>
      </div>
    </div>
  )
}
